import { LANDING_TYPE } from '@/types/landingTypes';
import { HOME_URL } from './urls';

export const HACKER_VIEW_STORAGE_LOCAL_KEY = 'SCAN_ITEMS';
export const DECISION_COOKIE_KEY = 'USER_DECISION'; // 0 - no, 1 - yes

export const TYPEWRITE_SPEED_INTERVAL = 50;

export const CAPTCHA_PASS_SCORE = 0.5;

// common paths
export const ROOT_PATH = '/';
export const RUN_SCAN = '/run-scan';
export const ROBOTS_TXT = '/robots.txt';
export const SITEMAP_XML = '/sitemap.xml';
export const FAVICON = '/favicon.ico';

export const ADVANTAGES_OPTIONS = [
  { id: '1', text: '$1M Identity Theft Insurance' },
  { id: '2', text: 'Continuous Dark Web monitoring' },
  { id: '3', text: 'Password Manager with automatic password change' },
  { id: '4', text: 'Credit and Financial monitoring' },
  { id: '5', text: 'Data broker opt-out' },
  { id: '6', text: '24/7 Customer Support' },
];

export const FREE_TOOLS_PATHS = {
  [LANDING_TYPE.HACKER_VIEW]: `${HOME_URL}/digital-footprint-checker`,
  [LANDING_TYPE.BREACH_CHECKER_EVERGREEN]: `${HOME_URL}/breach-checker`,
  'spot-the-scam': 'https://www.aura.com/resources/spot-the-scam',
};

export const CORS_WHITE_LIST_HOSTNAMES = [
  'onlineprivacypro.com',
  // TODO: remove when ready
  'cloudfront.net',
  // TODO: remove when ready
];
